import * as React from 'react';
import {useEffect} from 'react';
import {navigate} from 'router';
import SaleDelete from "~/apps/pos/admin/components/sales/SaleDelete";
import {deleteSale, getSaleById, getSaleList} from "~/apps/pos/shared/actions/sales";
import {isSaleDeletable} from "~/apps/pos/shared/services/helpers";
import Loader from "~/common/components/Loader";
import {connect} from "react-redux";

type Props = {
  saleId: string;
  sales: any;
  dispatch: any;
  information: any;
}

const SaleDeletePopup = (props: Props) => {
  const { saleId, sales, dispatch, information } = props;

  const sale = sales.entities[saleId];

  useEffect(() => {
    if (!sale) dispatch(getSaleById(saleId));
  }, []);

  const onClose = () => {
    navigate('pos.admin.sales')
  }

  useEffect(() => {
    if (sale && !isSaleDeletable(sale.status, sale.paymentType)) onClose();
  }, [sale]);

  if (!sale || sales.ui.loading) {
    return <Loader className="load--ol"/>;
  }

  const onDelete = () => {
    dispatch(deleteSale(saleId)).then(() => {
      dispatch(getSaleList());
      onClose();
    })
  }

  return (
    <SaleDelete
      sale={sale}
      onClose={onClose}
      onDelete={onDelete}
      features={information.entities.features}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    sales: state.pos.sales,
    information: state.shared.information,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleDeletePopup)
